import { render, staticRenderFns } from "./DispatchRequestIcon.vue?vue&type=template&id=3e2ee2ee&"
import script from "./DispatchRequestIcon.vue?vue&type=script&lang=js&"
export * from "./DispatchRequestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports